import { PawPrint, Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { Copyright } from './Copyright';
import { NewsletterSignup } from './common/NewsletterSignup';

export function Footer() {
  return (
    <footer className="bg-accessible-gray-900 dark:bg-accessible-gray-800 high-contrast:bg-black text-white py-16">
      <div className="max-w-5xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-12 gap-y-10 mb-16">
          {/* Fundacja */}
          <div>
            <h2 className="heading-6-white mb-6">Fundacja Znajdki</h2>
            <ul className="space-y-3 text-[0.875em]">
              <li className="flex">
                <NavLink to="/" className="text-accessible-gray-300 hover:text-white transition-colors inline-flex items-center gap-2 group" title="Przejdź do strony głównej">
                  <PawPrint className="w-4 h-4 text-accessible-red-600 group-hover:scale-110 transition-transform" aria-hidden="true" />
                  <span className="body-small-white-90 no-margin">Fundacja Znajdki</span>
                </NavLink>
              </li>
              <li className="flex">
                <NavLink to="/aktualnosci" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Zobacz najnowsze aktualności">
                  Aktualności
                </NavLink>
              </li>
              <li className="flex">
                <NavLink to="/o-nas" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Poznaj naszą historię i misję">
                  O nas
                </NavLink>
              </li>
              <li className="flex">
                <NavLink to="/mapa-strony" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Zobacz mapę strony">
                  Mapa strony
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Adopcja */}
          <div>
            <h2 className="heading-6-white mb-6">Adopcja</h2>
            <ul className="space-y-3 text-[0.875em]">
              <li className="flex">
                <NavLink to="/adoptuj" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Dowiedz się więcej o procesie adopcji">
                  Proces adopcji
                </NavLink>
              </li>
              <li className="flex">
                <NavLink to="/zwierzeta" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Zobacz zwierzęta do adopcji">
                  Zobacz zwierzaki
                </NavLink>
              </li>
              <li className="flex">
                <NavLink to="/wirtualna-adopcja" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Dowiedz się więcej o adopcji wirtualnej">
                  Adopcja wirtualna
                </NavLink>
              </li>
              <li className="flex">
                <NavLink to="/dom-tymczasowy" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Zostań domem tymczasowym">
                  Dom tymczasowy
                </NavLink>
              </li>
              <li className="flex">
                <NavLink to="/historie-adopcyjne" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Przeczytaj historie adopcyjne naszych podopiecznych">Historie adopcyjne</NavLink>
              </li>
              <li className="flex">
                <NavLink to="/za-teczowym-mostem" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Wspomnienia naszych ukochanych podopiecznych">Za tęczowym mostem</NavLink>
              </li>
            </ul>
          </div>

          {/* Partnerzy */}
          <div>
            <h2 className="heading-6-white mb-6">Współpraca i wsparcie</h2>
            <ul className="space-y-3 text-[0.875em]">
              <li className="flex">
                <NavLink to="/przekaz-podatek" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Przekaż 1.5% podatku na pomoc zwierzętom">
                  Przekaż 1.5% podatku
                </NavLink>
              </li>
              <li className="flex">
                <NavLink to="/wsparcie" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Dowiedz się jak możesz nas wesprzeć">
                  Wesprzyj nas
                </NavLink>
              </li>
              <li className="flex">
                <NavLink to="/wolontariat" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Dołącz do naszego zespołu wolontariuszy">
                  Zostań wolontariuszem
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Informacje prawne */}
          <div>
            <h2 className="heading-6-white mb-6">Informacje prawne</h2>
            <ul className="space-y-3 text-[0.875em]">
              <li className="flex">
                <NavLink to="/sprawozdania" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Zobacz nasze sprawozdania finansowe">
                  Sprawozdania
                </NavLink>
              </li>
              <li className="flex">
                <NavLink to="/statut" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Zapoznaj się ze statutem fundacji">
                  Statut
                </NavLink>
              </li>
              <li className="flex">
                <NavLink to="/regulamin" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Przeczytaj regulamin">
                  Regulamin
                </NavLink>
              </li>
              <li className="flex">
                <NavLink to="/polityka-prywatnosci" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Zapoznaj się z polityką prywatności">
                  Polityka prywatności
                </NavLink>
              </li>
              <li className="flex">
                <NavLink to="/polityka-cookies" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Informacje o plikach cookies">
                  Polityka ciasteczek
                </NavLink>
              </li>
              <li className="flex">
                <NavLink to="/deklaracja-dostepnosci" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Zobacz deklarację dostępności">
                  Deklaracja dostępności
                </NavLink>
              </li>
            </ul>
          </div>
        </div>

        {/* Kontakt - sekcja horyzontalna */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 py-10 mb-10 border-t border-accessible-gray-800/30 dark:border-accessible-gray-700/30 high-contrast:border-white/30 max-w-4xl mx-auto text-left">
          <div className="flex items-center gap-4 justify-start group">
            <Phone className="w-6 h-6 text-accessible-red-600 group-hover:scale-110 transition-transform" aria-hidden="true" />
            <div>
              <h3 className="label-small-white mb-1">Telefon</h3>
              <a href="tel:+48664821160" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Zadzwoń do nas: 664 821 160">664 821 160</a>
            </div>
          </div>
          <div className="flex items-center gap-4 justify-start group">
            <Mail className="w-6 h-6 text-accessible-red-600 group-hover:scale-110 transition-transform" aria-hidden="true" />
            <div>
              <h3 className="label-small-white mb-1">Email</h3>
              <a href="mailto:znajdki2012@gmail.com" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Wyślij nam wiadomość: znajdki2012@gmail.com">znajdki2012@gmail.com</a>
            </div>
          </div>
          <div className="flex items-center gap-4 justify-start group">
            <MapPin className="w-6 h-6 text-accessible-red-600 group-hover:scale-110 transition-transform" aria-hidden="true" />
            <div>
              <h3 className="label-small-white mb-1">Adres</h3>
              <a href="https://maps.google.com/?q=Krusze+ul.+Kryształowa+171,+05-240+Tłuszcz" target="_blank" rel="noopener noreferrer" className="body-small-white-90 hover:text-white transition-colors no-margin" title="Zobacz naszą lokalizację na mapie">
                <span className="block">Fundacja Znajdki</span>
                <span className="block">Krusze ul. Kryształowa 171</span>
                <span className="block">05-240 Tłuszcz</span>
              </a>
            </div>
          </div>
        </div>

        <section className="mt-4 mb-8">
          <div className="bg-white text-accessible-gray-900 rounded-2xl p-8 md:p-10 shadow-lg border border-accessible-gray-100">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 lg:gap-16 items-center">
              <div className="flex flex-col items-center sm:items-start gap-4 text-center sm:text-left">
                <img
                  src="/images/partners/Warszawa-znak-RGB-kolorowy-projekt_wspolfinansuje.png"
                  alt="Herb Warszawy"
                  className="h-24 md:h-28 w-auto"
                  loading="lazy"
                />
                <NavLink
                  to="/dofinansowania"
                  className="text-accessible-red-700 hover:text-accessible-red-800 font-semibold underline underline-offset-4 text-sm"
                  title="Zobacz listę projektów dofinansowanych przez władze miasta"
                >
                  Zobacz wszystkie dofinansowania
                </NavLink>
              </div>

              <div className="flex flex-col items-center md:items-end gap-4 text-center md:text-right md:border-l md:border-accessible-gray-200 md:pl-8 lg:pl-10">
                <div className="flex items-center gap-6">
                  <NavLink
                    to="/deklaracja-dostepnosci#etr"
                    className="inline-flex items-center justify-center rounded-xl border border-transparent hover:border-accessible-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-accessible-red-600 transition-all"
                    aria-label="Przejdź do sekcji tekstu łatwego do czytania (ETR) w deklaracji dostępności"
                    title="Deklaracja dostępności - strona przygotowana w tekście łatwym do czytania (ETR)"
                  >
                    <img
                      src="/images/partners/ETR-logo.jpg"
                      alt="Symbol tekstu łatwego do czytania ETR"
                      className="h-16 md:h-16 w-auto"
                      loading="lazy"
                    />
                  </NavLink>
                  <a
                    href="https://zrzutka.pl/en/profile/znajdki-przytulisko-kolo-radzymina-731453"
                    target="_blank"
                    rel="noopener nofollow"
                    className="inline-flex"
                    aria-label="Przejdź do profilu Fundacji Znajdki na Zrzutka.pl"
                    title="Wesprzyj nas przez Zrzutka.pl - odwiedź nasz profil"
                  >
                    <img
                      src="/images/partners/zrzutka_color_dark_text_horizontal.svg"
                      alt="Logo Zrzutka.pl"
                      className="h-10 md:h-12 w-auto"
                      loading="lazy"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Newsletter */}
        <div className="mb-12">
          <NewsletterSignup />
        </div>

        <div className="border-t border-accessible-gray-800/30 dark:border-accessible-gray-700/30 high-contrast:border-white/30 pt-10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 max-w-4xl mx-auto">
            <Copyright />
            <div className="flex gap-6">
              <a 
                href="https://www.facebook.com/znajdki/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="body-small-white-90 hover:text-white transition-colors group no-margin tap-target"
                title="Odwiedź nas na Facebooku"
                aria-label="Facebook"
              >
                <Facebook className="w-[1.5em] h-[1.5em] group-hover:scale-110 transition-transform" />
              </a>
              <a 
                href="https://www.instagram.com/fundacja_znajdki/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="body-small-white-90 hover:text-white transition-colors group no-margin tap-target"
                title="Śledź nas na Instagramie"
                aria-label="Instagram"
              >
                <Instagram className="w-[1.5em] h-[1.5em] group-hover:scale-110 transition-transform" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}